export const MOBILE_LIMIT = 767; // Copy of scss settings
